import React from 'react'

const SatQuestionTable = ({
  data = [],
  module = 1,
  sectionId = 1, // 1 for R&W, 2 for Math
  onVideoReview = () => {},
  onBookmark = () => {},
  onNote = () => {},
  onViewQuestion = () => {},
  rolename = '',
  handleSelectChange = () => {},
  vstatus = false,
}) => {
  // Filter data for the current module and section
  const filtered = data.filter(
    (item) =>
      String(item.section_id) === String(sectionId) &&
      String(item.module_id) === String(module)
  )

  if (filtered.length === 0) return null

  return (
    <div className="mb-8">
      <div className="bg-[#F8F8F8] text-[#222] text-lg font-bold px-6 py-3 rounded-t-xl border border-[#F0F0F0] border-b-0 text-center">
        Module: {module}
      </div>
      <div className="overflow-x-auto bg-white rounded-b-xl border border-[#F0F0F0]">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-[#F8F8F8] text-[#535862] font-semibold">
              <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                Question
              </th>
              <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                Topic
              </th>
              <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                Sub Topic
              </th>
              <th className="py-3 px-4 text-center border-r border-[#F0F0F0]">
                Correct Answer
              </th>
              <th className="py-3 px-4 text-center border-r border-[#F0F0F0]">
                Your Answer
              </th>
              {vstatus && (
                <th className="py-3 px-4 text-center border-r border-[#F0F0F0]">
                  Video Review
                </th>
              )}
              <th className="py-3 px-4 text-center">View Question</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((item, idx) => {
              console.log(
                'DEBUG ROW:',
                'selectedAnswer:',
                item.selectedAnswer,
                'correct_answer:',
                item.correct_answer,
                'status:',
                item.status,
                'Array includes:',
                Array.isArray(item.correct_answer)
                  ? item.correct_answer.includes(item.selectedAnswer)
                  : undefined
              )
              return (
                <tr key={item._id || idx} className="border-t border-[#F0F0F0]">
                  <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                    {idx + 1}
                  </td>
                  <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                    {item.topic_title}
                  </td>
                  <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                    {item.stopic_title}
                  </td>
                  <td className="py-2 px-4 text-center border-r border-[#F0F0F0]">
                    {Array.isArray(item.correct_answer)
                      ? item.correct_answer[0]
                      : item.correct_answer}
                  </td>
                  <td className="py-2 px-4 text-center border-r border-[#F0F0F0]">
                    {rolename === 'admin' ? (
                      <div className="relative inline-block">
                        <select
                          onChange={(e) =>
                            handleSelectChange(
                              item._id,
                              e.target.value,
                              item.correct_answer
                            )
                          }
                          value={item.selectedAnswer || ''}
                          className="appearance-none px-3 py-1.5 bg-white border border-[#E5E7EB] rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:border-transparent transition-all duration-200 pr-8 w-[80px]"
                          style={{
                            color: Array.isArray(item.correct_answer)
                              ? item.correct_answer.includes(
                                  item.selectedAnswer
                                )
                                ? '#3BBC4C'
                                : '#E90004'
                              : item.selectedAnswer === item.correct_answer
                              ? '#3BBC4C'
                              : '#E90004',
                            cursor: 'pointer',
                            WebkitAppearance: 'none',
                            MozAppearance: 'none',
                          }}
                        >
                          <option
                            value=""
                            className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                          >
                            Select
                          </option>
                          {['A', 'B', 'C', 'D'].map((option) => (
                            <option
                              key={option}
                              value={option}
                              className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                            >
                              {option}
                            </option>
                          ))}
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
                          <svg
                            className="fill-current h-4 w-4 text-[#535862]"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                          >
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                          </svg>
                        </div>
                      </div>
                    ) : (
                      <span
                        className={
                          Array.isArray(item.correct_answer)
                            ? item.correct_answer.includes(item.selectedAnswer)
                              ? 'font-semibold text-[#3BBC4C]'
                              : 'font-semibold text-[#E90004]'
                            : item.selectedAnswer === item.correct_answer
                            ? 'font-semibold text-[#3BBC4C]'
                            : 'font-semibold text-[#E90004]'
                        }
                      >
                        {item.selectedAnswer}
                      </span>
                    )}
                  </td>
                  {vstatus && (
                    <td
                      className="py-2 px-4 text-center border-r border-[#F0F0F0]"
                      style={{ verticalAlign: 'middle' }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '100%',
                        }}
                      >
                        <button
                          style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            margin: 0,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '32px',
                            width: '40px',
                            borderRadius: '10px',
                            border: '1px solid #F0F0F0',
                            background: '#FAFAFA',
                          }}
                          onClick={() => onVideoReview(item._id)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M17.7938 5.81875C17.4742 5.66355 17.1172 5.6023 16.7642 5.64213C16.4113 5.68197 16.0769 5.82124 15.8 6.04375L14.1875 7.3375V6.25C14.1875 5.75272 13.99 5.27581 13.6383 4.92417C13.2867 4.57254 12.8098 4.375 12.3125 4.375H3.3125C2.81522 4.375 2.33831 4.57254 1.98667 4.92417C1.63504 5.27581 1.4375 5.75272 1.4375 6.25V13.75C1.4375 14.2473 1.63504 14.7242 1.98667 15.0758C2.33831 15.4275 2.81522 15.625 3.3125 15.625H12.3125C12.8098 15.625 13.2867 15.4275 13.6383 15.0758C13.99 14.7242 14.1875 14.2473 14.1875 13.75V12.6625L15.8 13.9563C16.1332 14.2236 16.5478 14.3691 16.975 14.3687C17.2584 14.3677 17.5381 14.3036 17.7938 14.1813C18.1117 14.0284 18.38 13.789 18.5679 13.4905C18.7559 13.192 18.8558 12.8465 18.8563 12.4937V7.5C18.8546 7.14832 18.7542 6.80418 18.5663 6.50689C18.3784 6.2096 18.1107 5.97114 17.7938 5.81875ZM12.9375 13.75C12.9375 13.9158 12.8717 14.0747 12.7544 14.1919C12.6372 14.3092 12.4783 14.375 12.3125 14.375H3.3125C3.14674 14.375 2.98777 14.3092 2.87056 14.1919C2.75335 14.0747 2.6875 13.9158 2.6875 13.75V6.25C2.6875 6.08424 2.75335 5.92527 2.87056 5.80806C2.98777 5.69085 3.14674 5.625 3.3125 5.625H12.3125C12.4783 5.625 12.6372 5.69085 12.7544 5.80806C12.8717 5.92527 12.9375 6.08424 12.9375 6.25V13.75ZM17.6063 12.5C17.6067 12.6183 17.5735 12.7342 17.5106 12.8344C17.4477 12.9346 17.3577 13.0149 17.251 13.0659C17.1444 13.117 17.0254 13.1367 16.9079 13.1228C16.7905 13.1089 16.6793 13.062 16.5875 12.9875L14.1875 11.0563V8.94375L16.5875 7.01875C16.6793 6.94424 16.7905 6.89732 16.9079 6.88344C17.0254 6.86956 17.1444 6.88929 17.251 6.94034C17.3577 6.9914 17.4477 7.07167 17.5106 7.17185C17.5735 7.27202 17.6067 7.38798 17.6063 7.50625V12.5Z"
                              fill="#535862"
                            />
                          </svg>
                        </button>
                      </div>
                    </td>
                  )}
                  <td
                    className="py-2 px-4 text-center"
                    style={{ verticalAlign: 'middle' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                      }}
                    >
                      <button
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px',
                          background: '#F4F4F4',
                          borderRadius: '16px',
                          padding: '10px 18px',
                          border: 'none',
                          cursor: 'pointer',
                          minWidth: 0,
                        }}
                        onClick={() => onViewQuestion(item._id)}
                      >
                        <span
                          style={{
                            color: '#030303',
                            textAlign: 'center',
                            fontFamily:
                              'Basis Grotesque Arabic Pro, sans-serif',
                            fontSize: 16,
                            fontStyle: 'normal',
                            fontWeight: 500,
                            lineHeight: '120%',
                            marginRight: 2,
                          }}
                        >
                          View
                        </span>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 14 14"
                            fill="none"
                          >
                            <path
                              d="M9.08829 7.00002C9.08829 8.15502 8.15495 9.08835 6.99995 9.08835C5.84495 9.08835 4.91162 8.15502 4.91162 7.00002C4.91162 5.84502 5.84495 4.91168 6.99995 4.91168C8.15495 4.91168 9.08829 5.84502 9.08829 7.00002Z"
                              stroke="#535862"
                              strokeWidth="1.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.00003 11.8242C9.0592 11.8242 10.9784 10.6108 12.3142 8.51082C12.8392 7.68832 12.8392 6.30582 12.3142 5.48332C10.9784 3.38332 9.0592 2.16998 7.00003 2.16998C4.94086 2.16998 3.0217 3.38332 1.68586 5.48332C1.16086 6.30582 1.16086 7.68832 1.68586 8.51082C3.0217 10.6108 4.94086 11.8242 7.00003 11.8242Z"
                              stroke="#535862"
                              strokeWidth="1.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </button>
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default SatQuestionTable
